import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AppNotificationClient,
  AppNotificationDto,
  GetAppNotificationsResponseModel,
} from "../../../../api/api";
import { Subscription } from "rxjs";
import { SignalRService } from "../../../../services/signal-r.service";
import { NavigationService } from "../../../../services/navigation.service";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { AppNotificationType } from "../../../../pages/dashboard/notification-page/components/notification-management/notification-management.component";

@Component({
  selector: "app-navbar-notification",
  templateUrl: "./navbar-notification.component.html",
})
export class NavbarNotificationComponent implements OnInit {
  public notifications: GetAppNotificationsResponseModel =
    new GetAppNotificationsResponseModel();
  public currentPage: number = 1;
  public pageSize: number = 10;
  unreadCount = 0;
  private subscriptions: Subscription[] = [];

  @ViewChild("navbarNotificationDropdown", { static: false })
  dropdown!: NgbDropdown;

  constructor(
    private _notificationsService: AppNotificationClient,
    protected navigationService: NavigationService,
    private signalRService: SignalRService,
  ) {}

  loadNotifications(page: number, pageSize: number): void {
    this._notificationsService
      .appNotification_GetAppNotificationUnReadCount()
      .subscribe((res) => {
        this.unreadCount = res.data ?? 0;
      });
    this._notificationsService
      .appNotification_GetAppNotifications(
        false,
        null,
        true,
        page,
        pageSize,
        null,
      )
      .subscribe((res) => {
        this.notifications = res;
      });
  }

  // readNotification(id: number): void {
  //     this._notificationsService.appNotification_ReadNotification(id)
  //         .subscribe(res => {
  //             this.loadStartNotifications();
  //         });
  // }

  loadStartNotifications(): void {
    this.currentPage = 1;
    this.loadNotifications(this.currentPage, this.pageSize);
  }

  handleNavigate(): void {
    this.navigationService.navigateByUrl("/dashboard/notifications");
    this.dropdown.close();
  }

  initHandlers(): void {
    this.subscriptions.push(
      this.signalRService.getNewNotificationEvent().subscribe(() => {
        this.loadStartNotifications();
      }),
    );
  }

  ngOnInit(): void {
    this.initHandlers();
    this.loadStartNotifications(); // Load initial notifications on component init
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
